import React, {useEffect, useState} from "react";
import './EdenredCallbackPage.scss'
import {useSearchParams} from "react-router-dom";
import logo from "../../Assets/Logos/bart.svg";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";

const EdenredCallbackPage:React.FC = () => {
    const [searchParams,] = useSearchParams();
    const [error, setError] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(true)
    useEffect(() => {
        const code = searchParams.get('code')
        const body = searchParams.get('state')
        axios.post(`${process.env.REACT_APP_BART_URL}/edenred/create-transaction/${code}`, JSON.parse(body ?? '{}'))
            .then(() => setError(false))
            .catch(() => setError(true))
            .finally(() => setLoading(false))

    }, [searchParams])
    if(loading) {
        return <Loader visible />
    }
    return (
        <div className="edenredCallbackPage__body">
            <img src={logo} alt="logo" className="edenredCallbackPage__body--logo"/>
            {
                error ? (
                    <>
                        <p className="edenredCallbackPage__body--successTxt">Une erreur est survenue.</p>
                        <p className="edenredCallbackPage__body--successSubtxt">Merci de fermer cette page et d&apos;essayer un autre moyen de paiement</p>
                    </>
                ) : (
                    <>
                        <p className="edenredCallbackPage__body--successTxt">Votre paiement a bien été soumis à Edenred.</p>
                        <p className="edenredCallbackPage__body--successSubtxt">Vous pouvez fermer cette fenêtre et reprendre votre navigation.</p>
                    </>
                )
            }
        </div>
    )
}

export default EdenredCallbackPage
